import { render, staticRenderFns } from "./dog.vue?vue&type=template&id=9b697ff2&scoped=true"
import script from "./dog.vue?vue&type=script&lang=js"
export * from "./dog.vue?vue&type=script&lang=js"
import style0 from "./dog.vue?vue&type=style&index=0&id=9b697ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b697ff2",
  null
  
)

export default component.exports